import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitTypeSelect } from '../traitTypes/TraitTypeSelect';
import { configTrait } from '../ConfigTrait';
function toSnakeCase(str) {
    if (!str)
        return '';
    return str
        .split(/(?=[A-Z])/)
        .join('_')
        .toLowerCase();
    /* return String(str)
      .replace(/^[^A-Za-z0-9]*|[^A-Za-z0-9]*$/g, '')
      .replace(/([a-z])([A-Z])/g, (m, a, b) => a + '_' + b.toLowerCase())
      .replace(/[^A-Za-z0-9]+|_+/g, '_')
      .toLowerCase(); */
}
export class TraitRegistryCssTransition extends TraitRegistryCategory {
    label = 'Animation';
    constructor(parent) {
        super(parent);
        this.addTransitions();
        this.addScales();
        super.init();
    }
    addTransitions() {
        // animatable properties
        transitionProperties.forEach(s => {
            this[`transition_${s}`] = () => new TraitTypeSelect({
                label: `Übergang ${s}`,
                default: '',
                init: '0.5s ease-in-out',
                hidden: true,
                select: () => [['0s'], ['0.6s ease'], ['0.3s ease-in-out'], ['0.3s linear'], ['0.3s ease-out 0.1s']],
                css: ({ at }) => [
                    {
                        k: 'transition',
                        v: `${toSnakeCase(at.key.split('transition_')[1]).replace('_', '-')} ${at.trait.value}`,
                        append: s === 'all' ? undefined : ', ',
                        prepend: s === 'all' ? ', ' : undefined,
                    },
                ],
            });
        });
    }
    addScales() {
        configTrait.scaleProperties.forEach(s => {
            this[`scale_${s}`] = () => new TraitTypeSelect({
                label: `Skalierung ${s}`,
                css: () => [],
                hidden: true,
                default: configTrait.scaleDefaultConfig[s],
                init: '',
                select: [['none'], ['ratio', 'diagonale'], ['width', 'Breite ↔'], ['height', 'Höhe ↕']],
            });
        });
    }
}
export const transitionProperties = [
    'all',
    'backdropFilter',
    'background',
    'backgroundColor',
    'backgroundImage',
    'backgroundPosition',
    'backgroundSize',
    'border',
    'borderBottom',
    'borderBottomColor',
    'borderBottomLeftRadius',
    'borderBottomRightRadius',
    'borderBottomWidth',
    'borderColor',
    'borderLeft',
    'borderLeftColor',
    'borderLeftWidth',
    'borderRadius',
    'borderRight',
    'borderRightColor',
    'borderRightWidth',
    'borderTop',
    'borderTopColor',
    'borderTopLeftRadius',
    'borderTopRightRadius',
    'borderTopWidth',
    'borderWidth',
    'bottom',
    'boxShadow',
    'clip',
    'clipPath',
    'color',
    'columnCount',
    'columnGap',
    'columnRule',
    'columnRuleColor',
    'columnRuleWidth',
    'columnWidth',
    'columns',
    'filter',
    'flex',
    'flexBasis',
    'flexGrow',
    'flexShrink',
    'font',
    'fontSize',
    'fontSizeAdjust',
    'fontStretch',
    'fontWeight',
    'gridColumnGap',
    'gridGap',
    'gridRowGap',
    'height',
    'left',
    'letterSpacing',
    'lineHeight',
    'margin',
    'marginBottom',
    'marginLeft',
    'marginRight',
    'marginTop',
    'mask',
    'maskPosition',
    'maskSize',
    'maxHeight',
    'maxWidth',
    'minHeight',
    'minWidth',
    'motionOffset',
    'motionRotation',
    'objectPosition',
    'opacity',
    'order',
    'outline',
    'outlineColor',
    'outlineOffset',
    'outlineWidth',
    'padding',
    'paddingBottom',
    'paddingLeft',
    'paddingRight',
    'paddingTop',
    'perspective',
    'perspectiveOrigin',
    'right',
    'scrollSnapCoordinate',
    'scrollSnapDestination',
    'shapeImageThreshold',
    'shapeMargin',
    'shapeOutside',
    'textDecoration',
    'textDecorationColor',
    'textEmphasis',
    'textEmphasisColor',
    'textIndent',
    'textShadow',
    'top',
    'transform',
    'transformOrigin',
    'verticalAlign',
    'visibility',
    'width',
    'wordSpacing',
    'zIndex',
];
export const mappedTransitionTransformProperties = [
    'translateX',
    'translateY',
    'translateZ',
    'rotate',
    'rotateX',
    'rotateY',
    'rotateZ',
    'scale',
    'scaleX',
    'scaleY',
    'scaleZ',
];
